import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLeetcodeComponent } from './simple-icons-leetcode.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLeetcodeComponent ],
    exports:      [ SimpleIconsLeetcodeComponent ],
    bootstrap:    []
})
export class SimpleIconsLeetcodeModule {}
